import { get, getAll } from './Provider';
import { IAbo } from './model/IAbo';

const RESOURCE = 'abos';

export const Abo = {
  get: (id: string) => get<IAbo>(RESOURCE, id),
  getAll: (query?: string) => getAll<IAbo>(`${RESOURCE}?${query || ''}`),
}